import React from 'react';
import PropTypes from 'prop-types';
import PanelStyles from './panelStyles';

const Panel = props => {
  return <PanelStyles {...props}>{props.children}</PanelStyles>;
};

Panel.propTypes = {
  children: PropTypes.node.isRequired,
};

const PanelLeft = props => {
  return <PanelStyles.LeftStyles>{props.children}</PanelStyles.LeftStyles>;
};

PanelLeft.propTypes = {
  children: PropTypes.node.isRequired,
};

const PanelRight = props => {
  return <PanelStyles.RightStyles>{props.children}</PanelStyles.RightStyles>;
};

PanelRight.propTypes = {
  children: PropTypes.node.isRequired,
};

Panel.Left = PanelLeft;
Panel.Right = PanelRight;

export default Panel;
